<template>
    <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-6">
        <a @click="openPage('/allForm')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
      </div>
    </div>
    <div class="box">
      <div class="p-20">
        <div class="row mt-10">
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label>Type</label>
              </b-col>
              <b-col sm="9">
                <b-form-select @change="changeFormType" name="formType" v-model="formType" :options="options" class="mb-3" />
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="row mt-10">
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label>Branch</label>
              </b-col>
              <b-col sm="9">
                <b-form-select name="branch" v-model="addData.branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
                <div v-if="branch_validate">
                    <span class="error">The Branch field is required.</span>
                  </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <form @submit.prevent="validateOutstanding" data-vv-scope="corporateOutstanding">
            <div class="row mt-30">
              <div class="col-sm-7">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Corporate ID</label>
                  </b-col>
                  <b-col sm="9">
                    <div class="custom-search-select">
                      <b-form-select :options="corporates" @change="changeCorporate" class="border-bottom" name="corporate_id" v-validate="'required'" v-model="addData.corporate_id"/>
                    </div>
                    <span class="error">{{ errors.first('outstanding.corporate_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Month</label>
                  </b-col>
                  <b-col sm="9">
                    <div class="row">
                      <div class="col-6">
                        <b-form-select :disabled="!addData.corporate_id" v-validate="'required'" @change="getTotalMonth" class="border-bottom" name="month1" v-model="month1">
                          <option value="null">Please select</option>
                          <option v-for="itemMonth in getMonthData" :key="itemMonth.id" :value="itemMonth.fullDate">{{itemMonth.name_of_month}} {{itemMonth.year}}</option>
                        </b-form-select>
                        <span class="error">{{ errors.first('outstanding.month1') }}</span>
                      </div>
                      <div class="col-6">
                        <b-form-select :disabled="!month1" class="border-bottom" name="month2" @change="getTotalMonth" v-model="month2">
                          <option value="null">Please select</option>
                          <option v-for="itemMonth in endMonthData" :key="itemMonth.id" :value="itemMonth.fullDate">{{itemMonth.name_of_month}} {{itemMonth.year}}</option>
                        </b-form-select>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Total Month</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled name="outstanding_total" v-validate="'required|numeric'" v-model="addData.outstanding_total" type="text"></b-form-input>
                    <span class="error">{{ errors.first('outstanding.outstanding_total') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Payment Total</label>
                  </b-col>
                  <b-col sm="9">
                    <money :value="totalPayment" class="form-control border-bottom custom-currency w-100 bg-transparent" v-model="addData.payment_total" name="payment_total" v-bind="money2"></money>
                    <span class="error">{{ errors.first('outstanding.payment_total') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Processing Fee</label>
                  </b-col>
                  <b-col sm="9">
                    <money class="form-control border-bottom custom-currency w-100 bg-transparent" v-model="addData.processing_fee" name="processing_fee" v-bind="money2"></money>
                    <span class="error">{{ errors.first('outstanding.processing_fee') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Monthly Fee</label>
                  </b-col>
                  <b-col sm="9">
                    <money class="form-control border-bottom custom-currency w-100 bg-transparent" v-model="addData.monthly_fee" name="monthly_fee" v-bind="money2"></money>
                    <span class="error">{{ errors.first('outstanding.monthly_fee') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Employee ID</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select @change="getCSData" class="border-bottom" name="customer_service_id" v-validate="'required'" v-model="addData.customer_service_id">
                      <option :value="null">Please select</option>
                      <option v-for="item in dataCS" :key="item.id" :value="item.id">
                        <template v-if="item.branch">{{item.branch.codename}}</template><template v-else>XX</template>-{{item.id}}
                      </option>
                    </b-form-select>
                    <span class="error">{{ errors.first('freeze.customer_service_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Customer Service Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="CSName" type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Due Date</label>
                  </b-col>
                  <b-col sm="9">
                    <flat-pickr
                    v-model="addData.due_date"
                    name="due_date"
                    v-validate="'required'"
                    class="w-100"/>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="mt-20 mb-10">
              <div>Payment Methods</div>
              <hr class="short-line left mb-20">
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <div>Payment 1</div>
                    </b-col>
                    <b-col sm="9">
                      <div class="mb-20">
                        <b-form-select v-validate="'required'" @change="changePaymentType1" name="payment_type_id_1" v-model="addData.payment_type_id_1" class="form-control border-bottom">
                          <option :value="null" selected>Please select</option>
                          <option v-for="item in itemsPaymentType" :key="item.id" :value="item.id">{{item.name}}</option>
                        </b-form-select>
                        <span class="error">{{ errors.first('outstanding.payment_type_id_1') }}</span>
                      </div>
                      <div class="mb-10">
                        <b-form-radio-group class="radio-custom-list" @change="changePaymentCard1" :disabled="[1,6, 9].includes(addData.payment_type_id_1)" name="paymentCard1" v-model="addData.payment_card_id_1">
                          <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{item.name}}</b-form-radio>
                        </b-form-radio-group>
                        <div v-if="![1,9].includes(addData.payment_type_id_1) && addData.payment_type_id_1 != null && addData.payment_card_id_1 == null">
                          <span class="error">The payment_card_id_1 field is required.</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-lg-5">
                  <money class="form-control border-bottom custom-currency w-100" id="paymentFirstAmount" v-model="amountPaymentCard1" v-bind="money2"></money>
                  <div v-if="amountPaymentCard1 == '' || amountPaymentCard1 == null">
                    <span class="error">The payment first amount field is required.</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <div>Payment 2</div>
                    </b-col>
                    <b-col sm="9">
                      <div class="mb-20">
                        <b-form-select name="payment_type_id_2" @change="changePaymentType2" v-model="addData.payment_type_id_2" class="form-control border-bottom">
                          <option :value="null" selected>Please select</option>
                          <option v-for="item in itemsPaymentType2" :key="item.id" :value="item.id">{{item.name}}</option>
                        </b-form-select>
                      </div>
                      <div class="mb-10">
                        <b-form-radio-group class="radio-custom-list" @change="changePaymentCard2" :disabled="addData.payment_type_id_2 == 1 || addData.payment_type_id_2 == 6" name="paymentCard2" v-model="addData.payment_card_id_2">
                          <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{item.name}}</b-form-radio>
                        </b-form-radio-group>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-lg-5">
                  <money class="form-control border-bottom custom-currency w-100 bg-transparent" disabled v-model="amountPaymentCard2" :value="paymentLeft" v-bind="money2"></money>
                </div>
              </div>
              <div class="row">
                <b-col sm="2">
                  <div>Notes</div>
                </b-col>
                <b-col sm="10">
                  <textarea class="w-100" rows="5" v-model="addData.notes"></textarea>
                </b-col>
              </div>
            </div>
            <div class="text-right">
              <button type="submit" class="btn-primary">Submit</button>
            </div>
          </form>
          <div class="title font-300 font-15 mb-15">
            Corporate Member
          </div>
          <div class="box">
            <div class="p-15 pt-0">
              <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
                <template v-slot:cell(action)="data">
<!--                <template slot="action" slot-scope="data">-->
                  <b-btn @click="openPage('/memberEntry/editGym?id=' + data.item.id + '&member_id=' + $route.query.id)" size="sm" class="btn-table warning"><i class="fas fa-pen mr-5"></i>Edit</b-btn>
                </template>
                <template v-slot:cell(name)="data">
<!--                <template slot="name" slot-scope="data">-->
                  <template v-if="data.item.member">
                    {{data.item.member.first_name}} {{data.item.member.last_name}}
                  </template>
                </template>
                <template v-slot:cell(created_at)="data">
<!--                <template slot="created_at" slot-scope="data">-->
                  {{parseDate(data.item.created_at)}}
                </template>
              </b-table>
              <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
                  :total-pages="totalPage"
                  @page-changed="pageOneChanged"
                  prev-text="Prev" next-text="Next"/>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import { ModelSelect } from 'vue-search-select'
import Pagination from '@/views/component/pagination'

export default {
  name: 'addOutstanding',
  components: {
    ModelSelect,
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      corporates: [{ value: '', text: 'Please select' }],
      items: [],
      corporate_id : '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      sortType: '',
      itemsPaymentCard: [],
      itemsPaymentType: [],
      itemsPaymentType2: [],
      dataBranch: [],
      fields: [
        {
          key: 'id',
          label: 'Member ID',
          sortable: false
        },
        {
          key: 'first_name',
          label: 'Name',
          formatter: (value, key, item) => {
            return item.first_name + " " + item.last_name
          },
          sortable: false
        },
        {
          key: 'membership.name',
          label: 'Membership Name',
          sortable: false
        },
        {
          key: 'email',
          label: 'Email',
          sortable: false
        },
        {
          key: 'phone_number',
          label: 'Phone Number',
          sortable: false
        }
      ],
      config: {
        mode: "range",
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d"
      },
      monthNames: [
        {
          id: 1,
          name_of_month: 'January'
        },
        {
          id: 2,
          name_of_month: 'February'
        },
        {
          id: 3,
          name_of_month: 'March'
        },
        {
          id: 4,
          name_of_month: 'April'
        },
        {
          id: 5,
          name_of_month: 'May'
        },
        {
          id: 6,
          name_of_month: 'June'
        },
        {
          id: 7,
          name_of_month: 'July'
        },
        {
          id: 8,
          name_of_month: 'August'
        },
        {
          id: 9,
          name_of_month: 'September'
        },
        {
          id: 10,
          name_of_month: 'October'
        },
        {
          id: 11,
          name_of_month: 'November'
        },
        {
          id: 12,
          name_of_month: 'December'
        }
      ],
      branch_validate: false,
      addData: {
        corporate_id: '',
        outstanding_total: '',
        payment_total: '',
        customer_service_id: null,
        payment_type_id_1: null,
        payment_card_id_1: null,
        payment_type_id_2: null,
        payment_card_id_2: null,
        branch_id: null,
        notes: '',
        month: '',
        gross_amount: '',
        start_outstanding: '',
        end_outstanding: '',
        due_date: '',
        payment_amount_1: '',
        payment_amount_2: '',
        processing_fee: '',
        monthly_fee: ''
      },
      amountPaymentCard1: '',
      amountPaymentCard2: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR ',
        suffix: '',
        precision: 0,
        masked: false
      },
      month1: null,
      month2: null,
      getMonthData: [],
      endMonthData: [],
      formType: 'corporateOutstanding',
      options: [
        { value: null, text: 'Please select' },
        { value: 'freeze', text: 'Freeze' },
        { value: 'cancel', text: 'Cancel' },
        { value: 'outstanding', text: 'Outstanding' },
        { value: 'wristband', text: 'Wristband' },
        { value: 'lostAndFound', text: 'Lost & Found' },
        { value: 'dailyVisit', text: 'Daily Visit' },
        { value: 'grabAndGo', text: 'Grab & Go' },
        { value: 'grabAndGoGopay', text: 'Grab & Go Gopay' },
        { value: 'extendPt', text: 'Extend PT' },
        { value: 'corporateOutstanding', text: 'Corporate Invoice Outstanding' },
        { value: 'merchandise', text: 'Merchandise' },
        { value: 'starterPack', text: 'Starter Pack' }
      ],
      detailCS: {},
      CSName: '',
      dataCS: [],
    }
  },
  methods: {
      async changeBranch(event) {
        this.branch_validate = false
        axios.get('crm/v1/customer_service?branch_id=' + event).then(response => {
          this.dataCS = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })

        this.corporates = [{ value: '', text: 'Please select' }]

        let corporate = await axios.get('compro/v1/corporate?branch_id=' + event)
        corporate.data.data.rows.forEach(row => {
            this.corporates.push({ text: row.name, value: row.id })
        })

      },
      openPage(event) {
        this.$router.push(event);
      },
      async validateOutstanding () {
        if (![1,9].includes(this.addData.payment_type_id_1) && this.addData.payment_card_id_1 == null) {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
          return
        }
        if (this.addData.branch_id == null) {
          this.branch_validate = true
          this.$toast.success('The Branch field is required!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
          return
        }
        let isValid = await this.$validator.validateAll(this.formType)
        if(isValid) {
          this.addData.gross_amount = this.addData.payment_total
          this.addData.payment_amount_1 = this.amountPaymentCard1
          this.addData.payment_amount_2 = this.amountPaymentCard2
          this.addData.month = moment(this.month1 + '-01').format('MMMM') + ' - ' +  moment(this.month2 + '-01').format('MMMM')

          try {
            await axios.post('transaction/v1/transaction/outstanding_corporate', this.addData)
            this.$router.push('/allForm')
            this.$toast.success('data saved successfully!', 'Success', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
            })
          } catch (e) {
            this.$toast.success('cant saved data!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
            })
          }

        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
    },
    changeCorporate() {
      this.loadingActive = true
      this.corporate_id = this.addData.corporate_id
      this.corporateMember()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.corporateMember()
    },
    sortingChanged (event) {
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
      } else {
        this.sortType = 'desc'
      }
      this.fetchData()
    },
    getLastSixMonth () {
      var today = new Date()
      var dMonth
      for(var i = 6; i >= 0; i -= 1) {
        dMonth = new Date(today.getFullYear(), today.getMonth() - i, 1)
        var rawDataMonth = this.monthNames[dMonth.getMonth()]
        var singleYear = dMonth.getFullYear()
        var singleMonth = dMonth.getMonth() + 1
        var dataComplete = Object.assign({}, rawDataMonth, {year: dMonth.getFullYear()}, {fullDate: singleYear + '-' + singleMonth})
        this.getMonthData.push(dataComplete)
      }
    },
    getEndMonth () {
      var today = new Date()
      this.endMonthData = [].concat(this.getMonthData)

      for (var i = 1; i <= 3; i++) {
        var dMonth = new Date(today.getFullYear(), today.getMonth() + i, 1)
        var rawDataMonth = this.monthNames[dMonth.getMonth()]
        var singleYear = dMonth.getFullYear()
        var singleMonth = dMonth.getMonth() + 1
        var dataComplete = Object.assign({}, rawDataMonth, {year: dMonth.getFullYear()}, {fullDate: singleYear + '-' + singleMonth})
        this.endMonthData.push(dataComplete)
      }
    },
    dateRange (startDate, endDate) {
      var start      = startDate.split('-')
      var end        = endDate.split('-')
      var startYear  = parseInt(start[0])
      var endYear    = parseInt(end[0])
      var dates      = []

      for(var i = startYear; i <= endYear; i++) {
        var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1
        var startMon = i === startYear ? parseInt(start[1])-1 : 0
        for(var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j+1) {
          var month = j+1
          var displayMonth = month < 10 ? '0' + month : month
          dates.push([i, displayMonth, '01'].join('-'))
        }
      }
      return dates.length
    },
    async changePaymentCard1 (event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType = payment_card.data.data.rows
    },
    async changePaymentCard2 (event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType2 = payment_card.data.data.rows
    },
    changePaymentType1 (event) {
      if (event === 1) {
        this.addData.payment_card_id_1 = null
      } else if (event === 6) {
        this.addData.payment_card_id_1 = 1
      } else {
        this.addData.payment_card_id_1 = null
      }
    },
    changePaymentType2 (event) {
      if (event === 1) {
        this.addData.payment_card_id_2 = null
      } else if (event === 6) {
        this.addData.payment_card_id_2 = 1
      } else {
        this.addData.payment_card_id_2 = null
      }
    },
    getCSData (event) {
      axios.get('crm/v1/customer_service/' + event).then(response => {
        this.detailCS = response.data.data
        this.CSName = response.data.data.name
        this.addDataPrivy.customer_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    getTotalMonth (event) {
      if (this.month1 && this.month2) {
        this.addData.outstanding_total = this.dateRange(this.month1, this.month2)
      }

      this.addData.start_outstanding = moment(new Date(this.month1)).format('YYYY-MM-DD')
      this.addData.end_outstanding = moment(new Date(this.month2)).format('YYYY-MM-DD')
      this.addData.month = `${moment(this.addData.start_outstanding).format('MMMM')} - ${moment(this.addData.end_outstanding).format('MMMM')}`
    },
    changeFormType (event) {
      if (event === 'freeze') {
        this.$router.push('/allForm/addFreeze')
      } else if (event === 'cancel') {
        this.$router.push('/allForm/addCancel')
      } else if (event === 'outstanding') {
        this.$router.push('/allForm/addOutstanding')
      } else if (event === 'wristband') {
        this.$router.push('/allForm/addWristband')
      } else if (event === 'lostAndFound') {
        this.$router.push('/allForm/addLostAndFound')
      } else if (event === 'dailyVisit') {
        this.$router.push('/allForm/addDailyVisit')
      } else if (event === 'grabAndGo') {
        this.$router.push('/allForm/addGrabAndGo')
      } else if (event === 'grabAndGoGopay') {
        this.$router.push('/allForm/addgrabAndGoGopay')
      } else if (event === 'corporateOutstanding') {
        this.$router.push('/allForm/addCorporateOutstanding')
      } else if (event === 'extendPt') {
        this.$router.push('/allForm/addExtendPt')
      } else if (event === 'merchandise') {
        this.$router.push('/allForm/addMerchandise')
      } else if (event === 'starterPack') {
        this.$router.push('/allForm/addStarterPack')
      } else {
        this.$router.push('/allForm/add')
      }
    },
    async fetchData() {
      this.getLastSixMonth()
      this.getEndMonth()

      let corporate = await axios.get('compro/v1/corporate')
      corporate.data.data.rows.forEach(row => {
          this.corporates.push({ text: row.name, value: row.id })
      })

      let paymentCard = await axios.get('transaction/v1/payment_card?sorting=id&sorting_type=asc&status=active')
      this.itemsPaymentCard = paymentCard.data.data.rows

      let paymentType = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=1')
      this.itemsPaymentType = paymentType.data.data.rows
      this.itemsPaymentType2 = paymentType.data.data.rows

      let cs = await axios.get('crm/v1/customer_service/')
      this.dataCS = cs.data.data.rows

      if (Auth.Session.get().paradigm_role == 6 || Auth.Session.get().paradigm_role == '6') {
        // filter cs member
        this.dataCS = this.dataCS.filter(cs => cs.id == Auth.Session.get().paradigm_id)
      }

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows

        if (Auth.Session.get().paradigm_role == 6 || Auth.Session.get().paradigm_role == '6') {
          // filter branch member
          this.dataBranch = this.dataBranch.filter(branch => branch.id == Auth.Session.get().paradigm_branch_id)
        }
      }).catch(error => {
        console.log('error', error)
      })
    },
    async corporateMember() {
      let member = await axios.get('compro/v1/corporate/member/' + this.corporate_id + '?page=' + this.currentPage + '&limit=' + this.paginationLimit)
      this.items = member.data.data.rows
      this.totalPage = member.data.meta.pageCount
    }
  },
  computed: {
      totalPayment: function() {
        let calculatedTotal = this.addData.payment_total
        this.amountPaymentCard1 = this.addData.payment_total
        return calculatedTotal
      },
      paymentLeft: function() {
        if (String(this.amountPaymentCard1).length > String(this.addData.payment_total).length) {
            this.amountPaymentCard2 = 0
        } else {
            this.amountPaymentCard2 = this.addData.payment_total - this.amountPaymentCard1
            this.amountPaymentCard2 = Math.abs(this.amountPaymentCard2)
        }
      }
  },
  created () {
    this.fetchData()

    const roleId = Auth.Session.get().paradigm_role
    if (roleId == 6 || roleId == '6') {
      this.addData.branch_id = Auth.Session.get().paradigm_branch_id
      this.addData.customer_service_id = Auth.Session.get().paradigm_id

      this.getCSData(this.addData.customer_service_id)
    }
  }
}
</script>
